const UNHANDLED_VALUES = [0, null, undefined];

export const shouldDisplaySentiments = (campaigns) => {
  if (!campaigns) return false;
  let result = false;

  Object.values(campaigns).forEach((campaign) => {
    const { sentimentData } = campaign;

    if (!sentimentData) return;

    const { sentimentValues } = sentimentData;

    if (!sentimentValues) return;

    Object.entries(sentimentValues).forEach((item) => {
      const [, value] = item || {};
      if (!UNHANDLED_VALUES.includes(value)) result = true;
    });
  });

  return result;
};
